import React from 'react'
import { Stack } from '@mui/material'
import Button from '@/components/Button'
import { List } from './components'
import Text from '@/components/Text'

export interface InfoCardProps {
  onClick: () => void;
}

const InfoCard: React.FC<InfoCardProps> = (props) => {
  const { onClick } = props
  return (
    <>
      <Stack sx={{ margin: '0 5%' }}>
        <Text>实名认证</Text>

        <List>
          <Text size="xs" weight="thin">
            应法律法规相关要求，请您尽快完成实名认证
          </Text>
          <li>
            <Text size="xs" weight="thin">
              适用个人用户，账号归属于个人
            </Text>
          </li>
          <li>
            <Text size="xs" weight="thin">
              用一个身份信息仅可认证一个账号
            </Text>
          </li>
        </List>
      </Stack>
      <Button
        type="primary"
        sx={{
          marginLeft: '15%',
        }}
        onClick={onClick}
      >
        立即认证
      </Button>
    </>
  )
}

export default InfoCard
